import React from 'react';
import { Link } from 'react-router-dom'
import SocialList from 'components/SocialList';
import './nav.scss';

function scrollToTop(event: React.MouseEvent<HTMLAnchorElement>) {
  event.preventDefault();
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

function SideNav(props: any) {
  return (
    <nav className='nav'>
      <div className='nav-head'>
        <Link to='#' className='btn-menu' onClick={props.onClick}>
          <span className='menu-icon'>
            <i className='icn-close'></i>
            <i className='icn-menu'></i>
          </span>
          <span className='text'>
            <span className='text-default'>MENU</span>
            <span className='text-open'>CLOSE</span>
          </span>
        </Link>
      </div>

      <div className='nav-body'>
        <ul>
          <li>
            <a href='https://www.effy.me' target='_blank' rel='noreferrer'>
              Home
            </a>
          </li>
          {/* <li>
            <Link to='http://blog.effy.me' target='_blank' rel='noreferrer'>
              Blog
            </Link>
          </li> */}

          <li>
            <a href='https://www.effy.me/#works' target='_blank' rel='noreferrer'>
              Projects
            </a>
          </li>

          {/* <li>
            <Link to='http://blog.effy.me/about/' target='_blank' rel='noreferrer'>
              About
            </Link>
          </li> */}

          <li>
            <a href='mailto:effy.yin@gmail.com?subject=Hi'>Contact</a>
          </li>
        </ul>
      </div>

      <div className='nav-foot'>
        <div className='nav-foot-inner'>
          {/* <ul className='list-links'>
            <li>
              <Link to='https://www.weibo.com/effy-yin/' target='_blank' rel='noreferrer'>
                Wei
              </Link>
            </li>

            <li>
              <Link to='https://www.weibo.com/effy-yin/' target='_blank' rel='noreferrer'>
                bo
              </Link>
            </li>
          </ul> */}
          <SocialList />
        </div>

        <div className='nav-copyright'>© 2026 ❤️ Effy Yin</div>
      </div>

      <a href='#top' className='scrollto btn-gotop' onClick={scrollToTop} aria-label='Scroll to top'>
        <i className='icn-scroll-top'></i>
        <span>
          TO <br />
          TOP
        </span>
      </a>
    </nav>
  );
}

export default SideNav;
